import { render, staticRenderFns } from "./TheSupplierNavbarVertical.vue?vue&type=template&id=5334305a&"
import script from "./TheSupplierNavbarVertical.vue?vue&type=script&lang=js&"
export * from "./TheSupplierNavbarVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports